import { render } from "./SectionApresention.vue?vue&type=template&id=2be2739a&ts=true"
import script from "./SectionApresention.vue?vue&type=script&lang=ts"
export * from "./SectionApresention.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__